import { render, staticRenderFns } from "./formTambahRencanaAksi.vue?vue&type=template&id=40aeb5af&"
import script from "./formTambahRencanaAksi.vue?vue&type=script&lang=js&"
export * from "./formTambahRencanaAksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports